import React from 'react';
import Validate from './../common/validate';
import { userService } from './../../services/user.service';
import CommonMessage from './../common/commonMessage';
import ReactTooltip from 'react-tooltip';
import ReCAPTCHA from "react-google-recaptcha";
import { Redirect } from 'react-router-dom';
import $ from 'jquery';
import { SessionService } from './../../services/session.service';
import { loginService } from '../../services/login.service';

class SubAccountNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            username: "",
            ownername: "",
            passwordEmpty: false,
            passwordRegex: false,
            passwordStrength: "",
            isPasswordShow: false,
            message: "",
            isAction: false,
            token: this.props.match.params.token,
            redirect: "/login",
            isMounted: false,
        };
        this.passwordFocus = React.createRef();
        this.recaptchaRef = React.createRef();
        this.handleInputs = this.handleInputs.bind(this);
        this.createAccount = this.createAccount.bind(this);
        this.enterPressed = this.enterPressed.bind(this);
    }

    componentDidMount() {
        this.setState({
            isAction: true
        });
        this.cssLoad();
        this.getSubuserandOwnerDetails();
        loginService.clearLocalSession();
        this.setState({
            isMounted: true,
        });
    }

    cssLoad = () => {
        document.title = "IDrive® Compute | Sign up for an account";
    };
    enterPressed(event) {
        var code = event.keyCode || event.which;
        if(code === 13) {
            if(!this.state.isAction) {
                this.createAccount();
            }

        }

    }

    getSubuserandOwnerDetails = () => {
        userService.getsubuserandownerdetails(this.state.token).then((resp) => {
            if(resp === false) {
                this.setState({
                    message: "Error While Fetching details, try again!",
                    isAction: false
                });
                return;
            }
            if(resp.data.body.error) {
                this.props.history.push("/expired");
            }
            if(!resp.data.body.error) {
                this.setState({
                    ownername: resp.data.body.ownername,
                    username: resp.data.body.email,
                    isAction: false
                });
            }

        });
    };

    handleInputs = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        this.setState({
            [name]: value
        });

        if(name === "password") {

            if(value.length > 0) {
                this.setState({
                    passwordEmpty: false,
                    passwordRegex: false
                });
                if(Validate("password", value)) {
                    this.setState({
                        passwordStrength: "strong"
                    });

                }
                else {
                    this.setState({
                        passwordStrength: "weak"
                    });
                }
            } else {
                this.setState({
                    passwordEmpty: true,
                    passwordStrength: "",
                    passwordRegex: false
                });
            }
            var upCasePatt = new RegExp("[A-Z]");
            if(upCasePatt.test(value)) {
                $('#upperCaseLi').addClass("success");
            } else {
                $('#upperCaseLi').removeClass("success");
            }
            var lowCasePatt = new RegExp("[a-z]");
            if(lowCasePatt.test(value)) {
                $('#lowerCaseLi').addClass("success");
            } else {
                $('#lowerCaseLi').removeClass("success");
            }
            var numericPatt = new RegExp("[0-9]");
            if(numericPatt.test(value)) {
                $('#numericLi').addClass("success");
            } else {
                $('#numericLi').removeClass("success");
            }
            var specCharPat = /[`!@#$%^&*()_+\-={};':"|,.<>\/?~]/;
            if(specCharPat.test(value)) {
                $('#specCharLi').addClass("success");
            } else {
                $('#specCharLi').removeClass("success");
            }
            if(value.length >= 8) {
                $('#eightCharLi').addClass("success");
            } else {
                $('#eightCharLi').removeClass("success");
            }
        }


    };

    createAccount = () => {
        this.recaptchaRef.current.execute();
    };

    createUser = (event) => {
        localStorage.removeItem('phone');
        localStorage.removeItem('countryCode');
        if(this.state.password.length <= 0) {
            this.setState({
                passwordEmpty: true
            });
            this.passwordFocus.current.focus();
            return;
        }
        else {

            if(!Validate("password", this.state.password)) {
                this.setState({
                    passwordRegex: true
                });
                this.passwordFocus.current.focus();
                return;
            }

            else {
                const requestBody = {
                    email: this.state.username,
                    password: this.state.password,
                };
                this.setState({
                    isAction: true
                });
                userService.addsubuser(this.state.token, requestBody).then((resp) => {
                    if(resp === false) {
                        this.setState({
                            message: "Error while connecting, try again!",
                            isAction: false
                        });
                        if(this.recaptchaRef.current)
                            this.recaptchaRef.current.reset();
                        return;
                    }
                    if(resp.data.body.error) {
                        this.setState({
                            message: "Error while adding the user, try again!",
                            isAction: false
                        });
                        if(this.recaptchaRef.current)
                            this.recaptchaRef.current.reset();
                        return;
                    }
                    loginService.authenticate(event, JSON.stringify({ email: requestBody.email, password: requestBody.password })).then(authResp => {
                        if(!authResp.data?.error) {
                            userService.getUserData().then(response => {
                                loginService.setUserLocal(response, true);
                                this.setState({ redirect: authResp.data?.redirect });
                            }).catch(error => {
                                this.setState({
                                    wrongcreds: true,
                                    errmsg: "Error While trying to connect",
                                    isAction: false
                                });
                                if(this.recaptchaRef.current)
                                    this.recaptchaRef.current.reset();

                            });

                        }
                        else {
                            this.setState({
                                wrongcreds: true,
                                errmsg: "Invalid Username or Password",
                                isAction: false
                            });
                            if(this.recaptchaRef.current)
                                this.recaptchaRef.current.reset();
                        }
                    }).catch((err) => {
                        this.setState({
                            message: "Error while connecting, try again!",
                            isAction: false
                        });
                        if(this.recaptchaRef.current)
                            this.recaptchaRef.current.reset();
                        return;
                    });


                });
            }

        }

    };

    onRecaptchaChange = (event) => {
        this.createUser(event);

    };


    render() {
        if(SessionService.getCookie("isLoggedIn") && this.state.isMounted) {
            return <Redirect to={ this.state.redirect } replace={ true } />;
        }
        return (
            <body className="sub_accCreate_ui">
                <main>
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <div className="main_container">
                        <section className="main_section">
                            <div className="main_body_container">
                                <div className="subAcc_container_wrap">
                                    <div className="logo_wrap">
                                        <a href="https://www.idrivecompute.com" target="_blank"><span className="svg_wrap logo">
                                            <svg x="0px" y="0px" viewBox="0 0 143.8 58.5" enableBackground="new 0 0 143.8 58.5" xmlSpace="preserve">
                                                <g>
                                                    <g>
                                                        <g>
                                                            <g>
                                                                <path fill="#041823" d="M66.5,29.2c-0.2,1.2-1.3,3.6-4.7,3.6c-3.4,0-5.3-2-5.3-4.9c0-2.8,1.7-4.9,5.3-4.9c3.2,0,4.4,2,4.6,3.3      h-1.3c-0.4-1.6-1.7-2.2-3.3-2.2c-2.7,0-3.9,1.7-3.9,3.8c0,2.3,1.4,3.8,3.9,3.8c2,0,3-1.1,3.4-2.5H66.5z" />
                                                                <path fill="#041823" d="M61.8,33c-3.4,0-5.4-2-5.4-5.1c0-3.2,2.1-5.1,5.4-5.1c3.1,0,4.6,1.9,4.8,3.5l0,0.2H65l0-0.1      c-0.4-1.4-1.4-2.1-3.1-2.1c-2.3,0-3.7,1.4-3.7,3.6c0,2.3,1.4,3.6,3.7,3.6c1.7,0,2.8-0.8,3.2-2.4l0-0.1h1.7l0,0.2      C66.4,31,64.9,33,61.8,33z M61.8,23.1c-3.2,0-5.1,1.8-5.1,4.8c0,2.9,1.9,4.8,5.1,4.8c3.3,0,4.2-2.4,4.5-3.2h-0.9      c-0.4,1.6-1.7,2.5-3.5,2.5c-2.5,0-4.1-1.5-4.1-4s1.6-4,4.1-4c1.8,0,3,0.8,3.5,2.2h0.9C66,25.2,65.2,23.1,61.8,23.1z" />
                                                            </g>
                                                            <g>
                                                                <path fill="#041823" d="M73,22.9c3.6,0,5.3,2.3,5.3,4.9c0,2.6-1.7,4.9-5.3,4.9c-3.6,0-5.3-2.3-5.3-4.9      C67.7,25.3,69.4,22.9,73,22.9z M73,31.7c2.5,0,4-1.6,4-3.8c0-2.2-1.5-3.8-4-3.8c-2.5,0-4,1.6-4,3.8C69,30.1,70.5,31.7,73,31.7z" />
                                                                <path fill="#041823" d="M73,33c-3.8,0-5.5-2.6-5.5-5.1c0-2.6,1.7-5.1,5.5-5.1c3.8,0,5.5,2.6,5.5,5.1C78.5,30.4,76.8,33,73,33z       M73,23.1c-3.8,0-5.1,2.6-5.1,4.8c0,2.2,1.3,4.8,5.1,4.8c3.8,0,5.1-2.6,5.1-4.8C78.1,25.7,76.7,23.1,73,23.1z M73,31.9      c-2.5,0-4.2-1.6-4.2-4c0-2.4,1.6-4,4.2-4c2.5,0,4.2,1.6,4.2,4C77.1,30.3,75.5,31.9,73,31.9z M73,24.2c-2.3,0-3.8,1.4-3.8,3.6      c0,2.2,1.5,3.6,3.8,3.6c2.3,0,3.8-1.4,3.8-3.6C76.7,25.7,75.3,24.2,73,24.2z" />
                                                            </g>
                                                            <g>
                                                                <path fill="#041823" d="M94.5,26.6c0-1.7-0.8-2.6-2.8-2.6c-2.1,0-3.2,1.2-3.2,3l0,5.5h-1.3l0-6.3c0-1.2-0.8-2.2-2.7-2.2      c-1.9,0-3.3,1.1-3.3,3.2l0,5.3H80l0-9.3h1.3v1.7h0c0.6-1,1.6-2,3.7-2c2.1,0,3,1.1,3.3,2c0.4-0.9,1.8-2,3.7-2      c2.6,0,3.8,1.3,3.8,3.2l0,6.4h-1.3L94.5,26.6z" />
                                                                <path fill="#041823" d="M96.1,32.7h-1.7l0-6.1c0-1.7-0.8-2.4-2.6-2.4c-1.9,0-3,1-3,2.8l0,5.7h-1.7l0-6.5c0-1-0.6-2-2.5-2      c-1.9,0-3.1,1.1-3.1,3.1l0,5.4h-1.7l0-9.7h1.7v1.3c0.8-1.1,2-1.6,3.5-1.6c2.2,0,3,1.1,3.4,1.8c0.6-0.9,2-1.8,3.6-1.8      c2.6,0,4,1.3,4,3.4L96.1,32.7z M94.7,32.3h0.9l0-6.2c0-2-1.3-3.1-3.6-3.1c-1.7,0-3,1-3.5,1.9l-0.2,0.5L88.2,25      c-0.2-0.6-0.8-1.9-3.1-1.9c-1.6,0-2.8,0.6-3.5,1.9l-0.1,0.1h-0.3l0-0.2v-1.5h-0.9l0,8.9h0.9l0-5.1c0-2.1,1.3-3.4,3.5-3.4      c2.1,0,2.8,1.3,2.8,2.4l0,6.1h0.9l0-5.3c0-2,1.3-3.2,3.4-3.2c2,0,3,0.9,3,2.8L94.7,32.3z" />
                                                            </g>
                                                            <g>
                                                                <path fill="#041823" d="M97.9,23.2h1.3v1.9h0c0.3-0.8,1.2-2.2,3.8-2.2c3.8,0,5.1,2.7,5.1,4.9c0,2.6-1.6,4.9-5.1,4.9      c-1.8,0-3.2-1-3.8-2.2h0v5.5h-1.3V23.2z M103.1,31.7c2.1,0,3.7-1.5,3.7-3.8c0-1.9-1-3.8-3.7-3.8c-2.2,0-3.9,1.4-3.9,3.8      C99.2,29.8,100.4,31.7,103.1,31.7z" />
                                                                <path fill="#041823" d="M99.4,36.3h-1.7V23h1.7v1.4c0.6-0.9,1.6-1.7,3.6-1.7c3.9,0,5.3,2.8,5.3,5.1c0,2.4-1.4,5.1-5.3,5.1      c-1.5,0-2.8-0.7-3.6-1.7V36.3z M98.1,36H99v-5.5h0.3l0.1,0.1c0.5,1,1.9,2,3.6,2c3.6,0,4.9-2.6,4.9-4.8c0-2.3-1.3-4.8-4.9-4.8      c-1.8,0-3,0.7-3.6,2l-0.1,0.1h-0.3l0-0.2v-1.7h-0.9V36z M103.1,31.9c-2.8,0-4.1-2-4.1-4c0-2.4,1.6-4,4.1-4c2.9,0,3.9,2.2,3.9,4      C107,30.2,105.4,31.9,103.1,31.9z M103.1,24.2c-2.3,0-3.7,1.4-3.7,3.6c0,1.8,1.1,3.6,3.7,3.6c2.1,0,3.6-1.5,3.6-3.6      C106.6,26.1,105.7,24.2,103.1,24.2z" />
                                                            </g>
                                                            <g>
                                                                <path fill="#041823" d="M117.8,30.7L117.8,30.7c-0.4,1-1.8,2.1-3.9,2.1c-3.1,0-4-1.6-4-3.8v-5.8h1.3v6c0,1.8,1.1,2.5,2.8,2.5      c2.6,0,3.8-1.3,3.8-3.4v-5.1h1.3l0,9.3h-1.3L117.8,30.7z" />
                                                                <path fill="#041823" d="M113.9,33c-2.8,0-4.2-1.3-4.2-4v-6h1.7v6.2c0,1.6,0.8,2.3,2.6,2.3c2.4,0,3.6-1.1,3.6-3.2V23h1.7l0,9.7      h-1.7l0-1.4C116.9,32.3,115.6,33,113.9,33z M110.1,23.4V29c0,2.5,1.2,3.6,3.8,3.6c1.9,0,3.3-1,3.7-2l0-0.1h0.3l0,0.2l0,1.6h0.9      l0-8.9H118v4.9c0,2.3-1.4,3.6-4,3.6c-2,0-3-0.9-3-2.7v-5.8H110.1z" />
                                                            </g>
                                                            <g>
                                                                <path fill="#041823" d="M122.1,20.3h1.3v2.9h2.6v1h-2.6v6.2c0,0.8,0.3,1.2,1.3,1.2c0.6,0,1-0.1,1.3-0.1v1.1      c-0.5,0.1-1,0.1-1.5,0.1c-2.1,0-2.5-0.8-2.5-2.3v-6.1h-2v-1h2V20.3z" />
                                                                <path fill="#041823" d="M124.6,32.9c-2.3,0-2.7-1-2.7-2.5v-6h-2V23h2v-2.9h1.7V23h2.6v1.4h-2.6v6c0,0.7,0.2,1,1.1,1      c0.7,0,1-0.1,1.3-0.1l0.2,0v1.5l-0.2,0C125.5,32.8,125,32.9,124.6,32.9z M120.2,24h2v6.3c0,1.4,0.4,2.1,2.3,2.1      c0.4,0,0.8,0,1.3-0.1v-0.7c-0.3,0-0.7,0.1-1.1,0.1c-1.1,0-1.5-0.4-1.5-1.4V24h2.6v-0.6h-2.6v-2.9h-0.9v2.9h-2V24z" />
                                                            </g>
                                                            <g>
                                                                <path fill="#041823" d="M137.2,29.6c-0.5,1.6-1.9,3.3-5,3.3c-3.8,0-5.1-2.7-5.1-4.9c0-2.6,1.6-4.9,5.1-4.9      c2.4,0,5.3,1.1,5.3,5.3h-9c0,1.9,1.4,3.5,3.7,3.5c2.2,0,3.2-0.7,3.7-2.2H137.2z M136.1,27.2c-0.4-2.3-2.1-3.2-3.8-3.2      c-1.7,0-3.5,0.9-3.8,3.2H136.1z" />
                                                                <path fill="#041823" d="M132.2,33c-3.9,0-5.3-2.8-5.3-5.1c0-2.4,1.4-5.1,5.3-5.1c1.6,0,5.4,0.5,5.4,5.5v0.2h-9      c0.1,1.9,1.5,3.1,3.5,3.1c2,0,3-0.6,3.5-2l0-0.1h1.7l-0.1,0.3C137,30.9,135.8,33,132.2,33z M132.2,23.1c-3.6,0-4.9,2.6-4.9,4.8      c0,2.3,1.3,4.8,4.9,4.8c3.1,0,4.3-1.7,4.7-2.9H136c-0.6,1.5-1.7,2.2-3.8,2.2c-2.3,0-3.9-1.5-3.9-3.7V28h9      C137.2,23.8,134.1,23.1,132.2,23.1z M136.4,27.4h-8.1l0-0.2c0.3-2.5,2.3-3.3,4-3.3c2.2,0,3.7,1.2,4,3.3L136.4,27.4z M128.7,27      h7.2c-0.5-2.5-2.7-2.8-3.6-2.8C130.8,24.2,129.1,25,128.7,27z" />
                                                            </g>
                                                        </g>
                                                    </g>
                                                    <g>
                                                        <g>
                                                            <path fill="#7D8A8E" d="M58.5,45.5c0-0.3,0-0.8,0-1.2v-5h1.1v2.5h0c0.3-0.4,0.7-0.7,1.4-0.7c1,0,1.8,0.9,1.8,2.1     c0,1.5-1,2.3-1.9,2.3c-0.5,0-1-0.2-1.3-0.7h0l-0.1,0.6H58.5z M59.6,43.8c0,0.1,0,0.2,0,0.3c0.1,0.4,0.5,0.7,0.9,0.7     c0.7,0,1.1-0.5,1.1-1.4c0-0.7-0.4-1.3-1.1-1.3c-0.4,0-0.8,0.3-0.9,0.8c0,0.1,0,0.2,0,0.3V43.8z" />
                                                            <path fill="#7D8A8E" d="M64.2,41.3l0.8,2.3c0.1,0.3,0.2,0.6,0.2,0.8h0c0.1-0.2,0.1-0.6,0.2-0.8l0.7-2.3h1.1l-1.1,2.9     c-0.6,1.6-1,2.3-1.5,2.7c-0.4,0.4-0.8,0.5-1.1,0.5l-0.2-0.9c0.2,0,0.4-0.1,0.6-0.3c0.2-0.1,0.4-0.4,0.6-0.7     c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1-0.1-0.2L63,41.3H64.2z" />
                                                        </g>
                                                    </g>
                                                    <g>
                                                        <g>
                                                            <path fill="#7D8A8E" d="M70.2,39.7C70.1,39.8,70,40,70,40.2v5.4h1.3v-6h-0.6C70.5,39.5,70.4,39.6,70.2,39.7z" />
                                                            <path fill="#7D8A8E" d="M74.4,39.5h-1.8c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5v5.4H74c0.6,0,1.1,0,1.3-0.1     c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.2,0.6-0.6,0.8-1c0.2-0.4,0.3-0.9,0.3-1.4c0-1-0.2-1.8-0.7-2.3C76.1,39.8,75.3,39.5,74.4,39.5z      M75.5,44c-0.3,0.3-0.7,0.5-1.3,0.5h-1v-3.9h1.2c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.4,0.8,0.4,1.5C75.9,43.2,75.8,43.7,75.5,44z" />
                                                            <path fill="#7D8A8E" d="M80.1,40.9c-0.3,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.8,0.4c-0.2,0.2-0.4,0.4-0.6,0.7     c-0.1,0.3-0.2,0.7-0.2,1.1v2.2h1.3v-2.4c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.2,0.8-0.2h0.4v-1.2h-0.1L80.1,40.9L80.1,40.9z" />
                                                            <path fill="#7D8A8E" d="M81.3,40.9h-0.7v4.6H82v-4c0-0.2-0.1-0.3-0.2-0.4C81.6,40.9,81.5,40.9,81.3,40.9z" />
                                                            <path fill="#7D8A8E" d="M86,40.9c-0.3,0-0.5,0.1-0.6,0.4l-0.9,2.8l-1-3.3h-1.4l1.7,4.6h1.3l1.7-4.6H86z" />
                                                            <path fill="#7D8A8E" d="M81.2,39.2c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7     C80.5,39.5,80.8,39.2,81.2,39.2z" />
                                                            <path fill="#7D8A8E" d="M90.8,41.4c-0.4-0.4-1-0.6-1.7-0.6c-0.7,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.7c0,0.8,0.2,1.4,0.6,1.8     c0.4,0.4,0.9,0.6,1.6,0.6c0.6,0,1.1-0.1,1.4-0.4c0.4-0.3,0.6-0.6,0.8-1.1h-0.9c-0.1,0-0.3,0-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.1     c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.8h3.2     c0,0,0-0.1,0-0.1v-0.1v-0.1C91.4,42.4,91.2,41.8,90.8,41.4z M88.2,42.7c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.2,0.7-0.2     c0.3,0,0.5,0.1,0.7,0.2c0.2,0.2,0.2,0.4,0.3,0.7H88.2z" />
                                                        </g>
                                                    </g>
                                                    <g>
                                                        <g>
                                                            <path fill="#7D8A8E" d="M92,39.9c0,0-0.1-0.1-0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1-0.1-0.2     c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.3,0h0h-0.4v1.1h0.2v-0.5h0.1c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.2     l0.2,0.2h0.3l-0.1-0.2C92.1,40,92.1,39.9,92,39.9z M91.8,39.6C91.7,39.6,91.7,39.6,91.8,39.6h-0.2v-0.3h0.2c0,0,0,0,0.1,0     c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0.1C91.9,39.6,91.8,39.6,91.8,39.6z" />
                                                            <path fill="#7D8A8E" d="M92.5,39c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8     c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8C92.9,39.4,92.7,39.2,92.5,39z      M92.4,40.4c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.5-0.1-0.6-0.2c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0.1-0.5,0.3-0.6     c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.3,0.4,0.3,0.6C92.6,40,92.5,40.2,92.4,40.4z" />
                                                        </g>
                                                    </g>
                                                </g>
                                                <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="19.9446" y1="33.8268" x2="46.697" y2="33.8268">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_1_)" d="M46.6,25.9c-0.1-0.2-0.3-0.3-0.5-0.4l-11.2-5.9c-1.3-0.7-1.9-0.2-2.3-0.1l-2.5,1.2v1.6  c0,0.1-0.1,0.2-0.2,0.2l-1.8,1c-0.1,0-0.1,0.1-0.2,0c0,0,0,0,0,0l-1.7-1l-4.9,2.4l2,1c0.2,0.1,0.1,0.3,0.1,0.3v4.4  c0,0.2-0.1,0.4-0.3,0.4l-3.2,1.8v7.4c0,0.5,0.5,1.1,1,1.4l11.6,6.7c0.1,0,0.2,0.1,0.3,0.1c0.2,0.2,0.8,0,1.1-0.2l11.7-6.7  c0.5-0.2,1-0.9,1-1.4V26.3C46.7,26.1,46.7,26,46.6,25.9z" />
                                                <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="19.1839" y1="21.6563" x2="22.174" y2="21.6563">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_2_)" d="M19.3,22.5l1.3,0.8c0,0,0,0,0,0c0,0,0.1,0,0.1,0l1.3-0.8c0.1,0,0.1-0.1,0.1-0.2v-1.6c0,0,0,0,0,0  c0,0,0,0-0.1,0L20.8,20c-0.1-0.1-0.2,0-0.3,0l-1.3,0.6c0,0,0,0,0,0c0,0,0,0.1,0,0.1v1.6C19.2,22.5,19.2,22.5,19.3,22.5z" />
                                                <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="26.8804" y1="21.3102" x2="29.3575" y2="21.3102">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_3_)" d="M27,22.1l1,0.6c0,0,0,0,0,0c0,0,0.1,0,0.1,0l1.1-0.6c0,0,0.1-0.1,0.1-0.1v-1.3c0,0-0.1,0-0.1,0  c0,0-0.1,0-0.1,0l-1-0.6c-0.1-0.1-0.2,0-0.2,0l-1,0.5c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1v1.3C26.9,22,26.9,22,27,22.1z" />
                                                <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="9.7886" y1="27.9983" x2="12.2657" y2="27.9983">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_4_)" d="M9.9,28.8l1,0.6c0,0,0,0,0,0c0,0,0.1,0,0.1,0l1.1-0.6c0,0,0.1-0.1,0.1-0.1v-1.3c0,0-0.1,0-0.1,0  c0,0-0.1,0-0.1,0l-1-0.6c-0.1-0.1-0.2,0-0.2,0l-1,0.5c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1v1.3C9.8,28.7,9.8,28.7,9.9,28.8z" />
                                                <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="9.0455" y1="21.5939" x2="10.5318" y2="21.5939">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_5_)" d="M9.1,22.1l0.6,0.4c0,0,0,0,0,0c0,0,0,0,0.1,0l0.7-0.4c0,0,0.1-0.1,0.1-0.1v-0.8c0,0,0,0,0,0  c0,0,0,0,0,0l-0.6-0.4c-0.1,0-0.1,0-0.1,0l-0.6,0.3c0,0,0,0,0,0c0,0,0,0,0,0.1L9.1,22.1C9,22,9.1,22,9.1,22.1z" />
                                                <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="13.9997" y1="16.687" x2="16.976" y2="16.687">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_6_)" d="M14.1,17.6l1.3,0.8c0,0,0.1,0.1,0.2,0l1.3-0.8c0.1,0,0.1-0.1,0.1-0.2l0-1.5c0-0.1-0.1-0.2-0.1-0.2  l-1.2-0.6c-0.1-0.1-0.2,0-0.3,0l-1.3,0.6c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1v1.6C14,17.5,14,17.5,14.1,17.6z" />
                                                <linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="21.6786" y1="16.687" x2="24.6549" y2="16.687">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_7_)" d="M21.8,17.6l1.3,0.8c0,0,0.1,0.1,0.2,0l1.3-0.8c0.1,0,0.1-0.1,0.1-0.2l0-1.5c0-0.1-0.1-0.2-0.1-0.2  l-1.2-0.6c-0.1-0.1-0.2,0-0.3,0l-1.3,0.6c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1v1.6C21.7,17.5,21.7,17.5,21.8,17.6z" />
                                                <linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="13.5042" y1="23.8705" x2="16.9489" y2="23.8705">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_8_)" d="M13.6,24.9l1.5,0.9c0,0,0.1,0.1,0.2,0l1.5-0.9c0.1,0,0.1-0.1,0.1-0.2l0-1.8c0-0.1-0.1-0.2-0.1-0.2  L15.4,22c-0.2-0.1-0.2,0-0.3,0l-1.5,0.7c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1v1.8C13.5,24.8,13.6,24.9,13.6,24.9z" />
                                                <linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="13.2545" y1="34.2742" x2="17.2843" y2="34.2742">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_9_)" d="M13.4,35.5l1.8,1c0,0,0.1,0.1,0.2,0l1.8-1.1c0.1,0,0.1-0.1,0.1-0.2l0-2.1c0-0.2-0.1-0.2-0.1-0.2  L15.5,32c-0.2-0.1-0.3,0-0.4,0l-1.8,0.9c0,0,0,0-0.1,0.1c0,0,0,0.1,0,0.1v2.2C13.3,35.3,13.3,35.4,13.4,35.5z" />
                                                <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="17.2189" y1="28.8247" x2="21.7742" y2="28.8247">
                                                    <stop offset="0" style={ { stopColor: "#00ADFF" } } />
                                                    <stop offset="1" style={ { stopColor: "#15C1FF" } } />
                                                </linearGradient>
                                                <path fill="url(#SVGID_10_)" d="M17.3,30.2l2,1.2c0,0,0.1,0.1,0.2,0l2-1.2c0.1,0,0.2-0.2,0.2-0.2l0-2.4c0-0.2-0.1-0.2-0.2-0.3  l-1.9-1c-0.2-0.1-0.3,0-0.4,0l-2,1c-0.2,0.1-0.1,0.2-0.1,0.3V30C17.2,30,17.3,30.2,17.3,30.2z" />
                                                <path fill="#FFFFFF" d="M38.8,28c0,0,1.2,0.9,0.4,2.3l-0.7,1.3l-4.1-2.3c0,0-0.7-0.3-1.3,0l-3.2,1.7c0,0-0.6,0.2-0.6,0.7v3.6  c0,0-0.1,0.6,0.4,0.9l3.5,2c0,0,0.7,0.4,1.4,0l3.8-2.4l0.7,0.9c0,0,1.1,1.5-0.3,2.7l-4,2.5c0,0-0.7,0.5-1.8,0l-5.9-3.3  c0,0-0.9-0.3-0.7-1.4v-6.8c0,0-0.1-0.7,0.5-1.2l5.9-3.3c0,0,1-0.6,1.7-0.2L38.8,28z" />
                                            </svg>
                                        </span></a>
                                    </div>
                                    <div className="subUser_img_wrap">
                                        <figure></figure>
                                    </div>
                                    <p className="invite_content"><span className="usr_name">{ this.state.ownername }</span> has invited you to create an IDrive<sup>&reg;</sup> Compute account!</p>
                                    <div className="form_box" style={ { maxWidth: "440px" } } onKeyUp={ (e) => this.enterPressed(e) }>
                                        <h3>Sign up for an account!</h3>
                                        <div className="inp_row_wrap">
                                            <div className="common_txtBox_row">
                                                <label>Email<span className="sub_label">(This will be your login email)</span></label>
                                                <input type="text" value={ this.state.username } minLength="4" maxLength="20" className="txtBox" disabled></input>
                                            </div>
                                        </div>

                                        <div className="inp_row_wrap">
                                            <div className="common_txtBox_row pwd_field">
                                                <label>Password
                                                    { this.state.passwordStrength === "weak" ?
                                                        <span className="pwd_strength weak">Weak</span> : this.state.passwordStrength === "strong" ? <span className="pwd_strength strong">Strong</span> : <span></span> }
                                                </label>
                                                <div className="auth_box_wrap">
                                                    <input type={ this.state.isPasswordShow ? "text" : "password" } autoFocus={ true } ref={ this.passwordFocus } name="password" value={ this.state.password } className="txt_box" onChange={ this.handleInputs }></input>
                                                    <div className="id-tooltip id-tooltip-topright">
                                                        <p className="id-tooltip-note">Use atleast:</p>
                                                        <ul>
                                                            <li id="upperCaseLi">1 uppercase character</li>
                                                            <li id="lowerCaseLi">1 lowercase character</li>
                                                            <li id="numericLi">1 numerical digit</li>
                                                            <li id="specCharLi">1 special character</li>
                                                            <li id="eightCharLi">Min 8 characters</li>
                                                        </ul>
                                                    </div>
                                                    <span data-tip data-for="password" className={ this.state.isPasswordShow ? "pwd_field show_pwd" : "pwd_field" } onClick={ () => this.setState({ isPasswordShow: !this.state.isPasswordShow }) }></span>
                                                </div><ReactTooltip id="password" place="bottom" effect="solid">
                                                    { this.state.isPasswordShow ? "Hide" : "Show" }
                                                </ReactTooltip>
                                                <span className="err_msg" style={ { display: this.state.passwordEmpty ? 'inline-block' : 'none' } } >Password cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.passwordRegex ? 'inline-block' : 'none' } }>Password must meet the criteria</span>
                                            </div>
                                        </div>
                                        <div className="btn_wrap_icon">
                                            <input type="button" name="" value="Create my account" className="common_cta_btn blue" onClick={ this.createAccount }></input>

                                            <div className="common_page_loader">
                                                <span className="loader_icon"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
                <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: "" }) } />
                <div className="captcha">
                    <ReCAPTCHA
                        sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                        onChange={ (e) => this.onRecaptchaChange(e) }
                        ref={ this.recaptchaRef }
                        size="invisible"
                    />
                </div>
            </body>
        );
    }


}

export default SubAccountNew;